const MAX_FILE_SIZE = 1024 * 1024 * 500 // 500 MB

function intDiv(a: number, b: number): number {
  const result = a / b
  if (result >= 0) {
    return Math.floor(result)
  } else {
    return Math.ceil(result)
  }
}

function formatSize(size: number): string {
  // We really only need the first 4 or so, but doesn't hurt to add the rest
  const sizeSuffixes = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let s = size
  let n = intDiv(s, 1024)
  let i = 0
  while (n > 0) {
    s = n
    n = intDiv(n, 1024)
    i += 1
  }

  return `${s}${sizeSuffixes[i]}`
}

export function assertValidFileSize(file: File) {
  if (file.size > MAX_FILE_SIZE) {
    throw new Error(
      `File "${file.name}" is too large at ${formatSize(
        file.size,
      )}. Max file size is ${formatSize(MAX_FILE_SIZE)}.`,
    )
  }
}

export function assertValidFileType(file: File) {
  if (!file.type) {
    // Note:  Temporarily forgoing throwing to assess issue with file uploads concerning
    // proprietary file types from tax software.
    // throw new Error(`File "${file.name}" is of an unsupported type`)
    console.warn(`File "${file.name}" is of an unsupported type`)
  }
}
